import { STORYBOARD_TYPES } from "constants/storyboardType";
import { PAGE } from "constants/widgetTypes";
import _ from "lodash";

/* This helper will find the closestIndices using sliding window technique */
export const getClosestIndices = (pages, activePageId, limit) => {
  if (!pages || pages.length === 0 || !activePageId) return [];

  const sortedPages = _.sortBy(pages, "order");
  const total = sortedPages.length;

  if (total <= limit) return sortedPages;

  const activeIndex = sortedPages.findIndex((p) => p.id === activePageId);
  if (activeIndex === -1) return [];

  const half = Math.floor(limit / 2);
  let start = Math.max(0, activeIndex - half);
  let end = Math.min(total - 1, activeIndex + half);

  if (end - start + 1 < limit) {
    if (start === 0) end = Math.min(total - 1, start + limit - 1);
    else start = Math.max(0, end - limit + 1);
  }

  return sortedPages.slice(start, end + 1);
};

export const createPageTemplate = (pageId) => {
  return {
    id: pageId,
    type: PAGE,
    name: "Untitled Page",
    order: null,
    pageId,
    properties: {
      desktop: {
        alias: null,
        autoCreateAlias: true,
        container: {
          minWidth: 1200,
        },
        layout: {
          width: `${1200}px`,
          height: `${600}px`,
        },
      },
      mobile: {
        autoCreateAlias: true,
        container: {
          minWidth: 375,
        },
        layout: {
          width: `${375}px`,
          height: `${600}px`,
        },
      },
    },
  };
};
export const isIcV2 = (type) => type === STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2;

export const renameTheLabel = (type) => {
  if (type === STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2) {
    return STORYBOARD_TYPES.INTERACTIVE_CONTENT;
  }
  return type;
}